module.exports = __webpack_public_path__ + "static/davinta-a7e17a5926a50e22e1090b1727c17142.png";